(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/skeleton-coupon.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/skeleton-coupon.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.SkeletonCoupon = Backbone.Marionette.View.extend({
    className: 'bg-white',
    regions: {
      drawSelector: '#drawChooser',
      matchlist: '#matchlist',
      uSystem: '#uSignRow',
      bomben: '#additionalBombenGame'
    },

    templateContext: function() {
      var matchItems = [];
      var nrOfMatches = svs.tipset.data.gameDefinitions.numberOfMatches;
      var htmlClass = svs.tipset.data.gameDefinitions.htmlClass;
      var noDraws = svs.tipset.data.config.noDraws;
      var noOpenDrawsMessageStart = noDraws ? noDraws.errorText : 'just nu finns det ingen spelbar omgång';
      var noOpenDrawsMessageEnd = noDraws ? noDraws.errorTextEnd : '- Välkommen tillbaka!';

      for (var i = 0; i < nrOfMatches; i++) {
        matchItems.push({
          eventNumber: i + 1,
          htmlClass: htmlClass
        });
      }

      return {
        matches: matchItems,
        noOpenDrawsMessageEnd: noOpenDrawsMessageEnd,
        noOpenDrawsMessageStart: noOpenDrawsMessageStart
      };
    },

    template: function(data) {
      return svs.tipset.templates.skeletoncoupon(data);
    }
  });
})(Backbone, _, svs);

 })(window);